export const captionIds = {
    header: {
        create: { id: 'account.settings.locations.dialog.title.create' },
        edit: { id: 'account.settings.locations.dialog.title.edit' },
    },
    body: {
        form: {
            label: { id: 'account.settings.locations.dialog.form.label' },
            validation: {
                required: { id: 'form.errors.required' },
                maxLength: { id: 'form.errors.maxLength' },
                locationExist: { id: 'form.errors.location.exist' },
            },
        },
    },
    footer: {
        cancel: { id: 'common.cancel' },
        create: { id: 'account.settings.locations.dialog.title.create' },
        edit: { id: 'account.settings.locations.dialog.title.edit' },
    },
};
